import React, {Component} from "react";
import {Link} from "react-router-dom";
import classNames from "classnames";
import {Loader, Props, utils} from "@mc/mc-legacy";
import {connect} from "react-redux";
import "./LinkContainer.scss";
import * as schvaleniActions from "../actions/KeSchvaleniActions";
import * as podpisActions from "../actions/mojeUkolyActions";

const withRouter = require("react-router").withRouter;

class MobileTabContainer extends Component {

    componentDidMount() {
        this.fetchData(this.props);
    }

    fetchData() {
        const { dispatch } = this.props;
        dispatch(podpisActions.fetchIfNeeded(podpisActions.MU_NEVYRIZENE_LIST));
        dispatch(schvaleniActions.fetchIfNeeded(schvaleniActions.KE_SCHVALENI_LIST));
    }

    render() {
        const {
            podpisList,
            schvalovaniList,
            match,
        } = this.props;

        const podpisUrl = '/ukoly/nevyrizene'
        const podpisHistorieUrl = '/ukoly/historie'
        const schvaleniUrl = '/ukoly/schvaleniNevyrizene'
        const schvaleniHistorieUrl = '/ukoly/schvaleniHistorie'

        if (!podpisList.fetched || !schvalovaniList.fetched) {
            return <Loader />;
        }

        const isPodepisovaniPath = match.path === podpisUrl || match.path === podpisHistorieUrl;
        const isSchvalovaniPath = match.path === schvaleniUrl || match.path === schvaleniHistorieUrl;

        return (
            <div className={"link-container"}>
                <div className={classNames("tab", { active: isPodepisovaniPath })}>
                    <Link className={classNames("big-link", { active: isPodepisovaniPath })} to={podpisUrl}>
                        K podpisu ({Object.keys(podpisList.allIds).length})
                    </Link>
                </div>
                <div className={classNames("tab", { active: isSchvalovaniPath })}>
                    <Link
                        className={classNames("big-link", { active: isSchvalovaniPath })}
                        to={schvaleniUrl}
                    >
                        Ke schválení ({Object.keys(schvalovaniList.allIds).length})
                    </Link>
                </div>
                <div className={"tab dummy"} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        podpisList: utils.storeFromArea(state, podpisActions.MU_NEVYRIZENE_LIST),
        schvalovaniList: utils.storeFromArea(state, schvaleniActions.KE_SCHVALENI_LIST),
    };
}

export default withRouter(connect(mapStateToProps)(MobileTabContainer));
